import type { FaresRequestCopy } from '@voll-intelligence/intelligence-ui-kit';
import { genUiI18n } from './i18n.js';

/** O cabeçalho escrito do pedido na tela de tarifas do kit, no locale do host.
 *  Função pura, como o `flightFaresCopy`: o host memoiza por locale. */
export function faresRequestCopy(locale: string | null | undefined): FaresRequestCopy {
  const { t } = genUiI18n(locale);
  return {
    subtitle: (route, trip) => t('flightFares.subtitle', { route, trip }),
    subtitleWithTravelers: (route, trip, travelers) =>
      t('flightFares.subtitleWithTravelers', { route, trip, travelers }),
    trip: {
      one_way: t('flightPlanner.tripType.oneWay'),
      round_trip: t('flightPlanner.tripType.roundTrip'),
      multi_leg: t('flightPlanner.tripType.multiLeg'),
    },
    cabin: {
      economy: t('flightExplorer.cabin.economy'),
      premium: t('flightExplorer.cabin.premium'),
      business: t('flightExplorer.cabin.business'),
      first: t('flightExplorer.cabin.first'),
    },
    travelers: (count) =>
      t(count === 1 ? 'travelers.count_one' : 'travelers.count_other', { count }),
  };
}
